import { useNavigate } from "react-router-dom";
import useWindowFocus from "use-window-focus";
import Button from "../components/Inputs/Button";
import Session from "supertokens-web-js/recipe/session";
import { useUser } from "../hooks/useUser";
import { useEffect } from "react";
import config from "src/services/config";
declare global {
  namespace JSX {
    interface IntrinsicElements {
      "stripe-pricing-table": React.DetailedHTMLProps<
        React.HTMLAttributes<HTMLElement>,
        HTMLElement
      >;
    }
  }
}

const PastDue = () => {
  const { user, fetchUser } = useUser();
  const navigate = useNavigate();

  const windowFocused = useWindowFocus();

  useEffect(() => {
    if (user?.info?.subsciptionStatus === "active") {
      //navigate("/");
    }
  }, [user]);

  useEffect(() => {
    if (windowFocused) {
      fetchUser();
    }
  }, [windowFocused]);
  return (
    <div className="w-full flex justify-center">
      <div className="flex items-center justify-center h-screen m-auto w-auto relative">
        <div className="text-black top-[200px] flex w-full z-50 flex-col items-center bg-white py-4 px-12 rounded-xl shadow-lg border">
          <div className="flex flex-col items-center justify-start w-[360px]">
            <img src="logo.png" alt="" className="w-20 h-20" />
            <div className="font-semibold text-[25px] text-center mb-2 mt-2">
              <div className="font-semibold text-[30px] text-center mb-6 mt-2">
                Payment Update Required
              </div>
              <div className="text-center">
                Your recent payment was unsuccessful. Please update your billing
                information to avoid service interruption.
              </div>
              <div className="mb-6"></div>
              <div className="flex items-baseline w-64 flex-col gap-3">
                <Button
                  type="primary"
                  onClick={async () => {
                    const d = await fetch(
                      config.API_URL + "stripeRedirect",
                    ).then((a) => a.json());
                    window.open(d.url, "_blank");
                  }}
                >
                  Open billing settings
                </Button>

                <Button
                  type="secondary"
                  onClick={async () => {
                    navigate("/login");
                    await Session.signOut();
                  }}
                >
                  Sign out
                </Button>
              </div>
              information within the next 3 days to avoid service interruption.
            </div>
            <div className="mb-4"></div>
            <Button
              type="secondary"
              onClick={async () => {
                navigate("/login");
                await Session.signOut();
              }}
            >
              Sign out
            </Button>

            <div className="mb-6"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PastDue;
